



























































































































































import {
  Consultor,
  ConsultoresService,
  PlanoDto,
  TipoPlano,
} from "@/services/consultores.service";
import { LoginService } from "@/services/login.service";
import ComboPlanos from "@/shared/components/combo-planos.vue";
import DataTable from "@/shared/components/data-table.vue";
import DatePicker from "@/shared/components/date-picker.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import { date, dateTime, moeda, timeFromNow } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import dayjs from "dayjs";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import AssociarVendedor from "../modals/AssociarVendedor.vue";
import CancelarPlano from "../modals/CancelarPlano.vue";
import DetalhesPlano from "../modals/DetalhesPlano.vue";
import Manter from "../modals/Manter.vue";

@Component({
  components: {
    DataTable,
    ComboPlanos,
    DatePicker,
    Manter,
    DetalhesPlano,
    CancelarPlano,
    Tooltip,
    AssociarVendedor,
  },
  filters: { date, dateTime, timeFromNow, moeda },
})
export default class PlanosAba extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  selectRow = true;
  loading = false;
  consultor: Consultor | null = null;
  erroBoleto: string | null = "";
  promisePlanos: Promise<PlanoDto[]> | null = null;
  showBoleto?: boolean = false;
  planosService: PlanoDto[] = [];
  desabilitado = true;
  isAdmin = false;

  headersPlanos = [
    { value: "descricao", text: "Plano" },
    { value: "valor", text: "Valor" },
    { value: "desconto", text: "Desconto" },
    { value: "nomeVendedor", text: "Vendedor" },
    { value: "codCupom", text: "Cupom" },
    { value: "dataContratacao", text: "Data Contratação" },
    { value: "dataInicio", text: "Data Inicio" },
    { value: "dataExpiracao", text: "Data Expiração" },
    { value: "status", text: "Status" },
    { value: "actions", text: "Ação", sortable: false },
  ];

  async mounted() {
    await this.carregarPermissaoAdmin();
    this.fetchPlanos();
  }

  async carregarPermissaoAdmin() {
    const roles = await LoginService.GetRoleUsuario();
    this.isAdmin = roles.indexOf("Admin") > -1;
  }

  async adicionarPlano() {
    const existeAssinatura = this.consultaAssinatura();
    const modal = this.$refs.manter as Manter;
    await modal.novoPlano(this.idConsultor, existeAssinatura);
    this.fetchPlanos();
  }

  async fetchPlanos() {
    this.loading = true;
    try {
      this.promisePlanos = ConsultoresService.ListarPlanosDto(this.idConsultor);
      this.planosService = await this.promisePlanos;
    } finally {
      this.loading = false;
      this.desabilitado = false;
    }
  }

  async selecionadoPlano(item: PlanoDto) {
    if (!item.idPlano) {
      return;
    }

    const modal = this.$refs.detalhesPlano as DetalhesPlano;
    await modal.detalhesPlano(item.idPlano);
  }

  async cancelaPlano(item: PlanoDto) {
    if (!item.idPlano) {
      return;
    }

    const modal = this.$refs.cancelarPlano as CancelarPlano;
    await modal.cancelamentoPlano(this.idConsultor, item.idPlano);
    this.fetchPlanos();
  }

  podeAssociarVendedor(item: PlanoDto) {
    if (!this.isAdmin) {
      return false;
    }

    if (item.nomeVendedor || item.idUsuarioVendedor) {
      return false;
    }

    if (item.status !== 2 && item.status !== 4) {
      return false;
    }

    if (!item.dataContratacao) {
      return false;
    }

    if (item.valor <= 0) {
      return false;
    }

    const hoje = dayjs();
    const dataContratacao = dayjs(item.dataContratacao);

    if (!dataContratacao.isValid()) {
      return false;
    }

    if (dataContratacao.isSame(hoje, "month")) {
      return true;
    }

    const dataCorte = hoje.date() < 10;
    const mesAnterior = hoje.subtract(1, "month");

    return dataCorte && dataContratacao.isSame(mesAnterior, "month");
  }

  async abrirAssociarVendedor(item: PlanoDto) {
    if (!item.idPlano || !this.podeAssociarVendedor(item)) {
      return;
    }

    const modal = this.$refs.associarVendedor as AssociarVendedor;
    const associou = await modal.abrir(item.idPlano);

    if (associou) {
      this.fetchPlanos();
    }
  }

  textoTooltipVendedor(item: PlanoDto) {
    return `${item.nomeVendedor} (+${item.pontosBonificacao || 0} pontos)`;
  }

  fechaAlertaBoleto() {
    this.showBoleto = false;
  }

  setTipoPlano(status: number) {
    switch (status) {
      case 1:
        return TipoPlano["Gratis"];
      case 2:
        return TipoPlano["MensalLite"];
      case 3:
        return TipoPlano["TrimestralLite"];
      case 5:
        return TipoPlano["SemestralLite"];
      case 6:
        return TipoPlano["AnualLite"];
      case 7:
        return TipoPlano["BonusLite"];
      case 8:
        return TipoPlano["Mensal"];
      case 9:
        return TipoPlano["Trimestral"];
      case 10:
        return TipoPlano["Semestral"];
      case 11:
        return TipoPlano["Anual"];
      case 12:
        return TipoPlano["Bonus"];
    }
  }

  consultaAssinatura() {
    let valida = false;
    this.planosService.forEach((item) => {
      if (item.idTipoPlano === 7 && (item.status === 2 || item.status === 4)) {
        valida = true;
      }
    });
    return valida;
  }
}
